import { Box } from "@mui/material";
import { useState } from "react";
import DetailsDrug from "../../components/leaderGroup/drug/detailsDrug";
import NewDrug from "../../components/leaderGroup/drug/newDrug";
import AddBatchDrugToArea from "../../components/leaderGroup/drug/AddBatchDrugToArea";

export default function Drug({ notGroup }) {
  const [mode, setMode] = useState("table");

  return (
    <Box>
      {mode === "table" && (
        <DetailsDrug notGroup={notGroup} setMode={setMode} />
      )}
      {mode === "new" && <NewDrug setMode={setMode} />}
      {mode === "addBatchToArea" && (
        <>
          <Box>
            <AddBatchDrugToArea setMode={setMode} />
          </Box>
        </>
      )}
    </Box>
  );
}
